import { GridListItemProps } from "react-aria-components";
import { ReactNode } from "react";

export interface MDSGridListItemProps extends Omit<GridListItemProps, "children"> {
  children?: ReactNode;
  leftAddon?: ReactNode | null;
  rightAddon?: ReactNode | null;
}

export enum MDSGridListItemSlotName {
  LeftAddon = "leftAddon",
  RightAddon = "rightAddon",
}
